<script setup>
import { router, Head, Link, useForm, usePage } from '@inertiajs/vue3';
import { ref } from 'vue';

const props = defineProps({
  supervisor: Object,
});

const logout = () => {
    let slugs = {'subdomain':'reporting'};
    router.post(route('reporting.logout', slugs));
};

</script>
<template>
    <header id="sos-auditor-header" class="bg-white">

        <div class="container mx-auto flex flex-row items-center justify-between w-full pt-5 pb-5 bg-white pl-10 pr-10">
            <div id="sos-header-menu">
                <div id="header-brand">
                    {{ $t('reporting.header.title') }}
                </div>
            </div>
            <div v-if="props.supervisor">
               <button class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition whitespace-nowrap" @click="logout">
                    {{ $t('reporting.login.log_out') }}
               </button>
            </div>
        </div>
    </header>

</template>
